import { render } from "./SearchPageTwo.vue?vue&type=template&id=62107f9d&scoped=true"
import script from "./SearchPageTwo.vue?vue&type=script&lang=js"
export * from "./SearchPageTwo.vue?vue&type=script&lang=js"

import "./SearchPageTwo.vue?vue&type=style&index=0&id=62107f9d&scoped=true&lang=css"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62107f9d"]])

export default __exports__